import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { MenuService } from "../../../app/menu.service";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import moment from "moment-timezone";
import { ChangeDetectorRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatToolbar } from "@angular/material/toolbar";
import { MatDatepicker, MatDatepickerActions, MatDatepickerModule, MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatDateSelectionModel } from "@angular/material/datepicker";
import { MatFormField, MatFormFieldModule, MatHint, MatLabel } from "@angular/material/form-field";
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from "@angular/material/button";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
  standalone:true,
  imports: [
    MatPaginator,MatNativeDateModule, CommonModule,MatToolbar,MatDateRangeInput,MatDatepickerToggle,MatHint,MatFormField,ReactiveFormsModule,MatDateRangePicker,MatLabel,FormsModule,MatRadioModule,MatButtonModule,MatOption,MatSelect,MatDateRangePicker,MatDateRangeInput,MatDatepickerModule,MatFormFieldModule]
})
export class ReportsComponent implements OnInit {
  public assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  public report_generate = BaseUrlConstantsService.Generate_new_url;
  public productApi = BaseUrlConstantsService.PRODUCT_LIST_API;
  hide: boolean = true;
  public myDate: Date;
  public today: any;
  public allDevices: any = [];
  public clientId: any;
  public siteList: any = [];
  public groupList: any = [];
  public devices: any = [];
  public searchText: any;
  public allDeviceSecondArray: any = [];
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public emptyMsgSHOW: string;
  public checked = false;
  public assetList: any = [];
  public assets: any = [];
  public term: any;
  public termassetname: any = "";
  public termcompanyname: any = "";
  public masterselected: any;
  public pdf_url="";

  public showFilter = false;
  public selectValueArr = [];
  public assetsAll: any = [];
  public arrListAssets: any;
  public gridLayoutOn = true;
  public listLayoutOn: boolean;
  public chartBoxVisibility: boolean;
  public sensorDataArr = [];
  public selectedSite: string = "All Sites";
  public selectedReportType: string = 'all';
  public Onprem = BaseUrlConstantsService.ON_PREM;
  public breadcrumbsArray: any = [
    {
      page_ref: "/reports",
      page_title: "Reports",
    },
  ];
  public filterList = [
    {
      title: "All Assets",
      value: "1",
    },
    {
      title: "ERROR",
      value: "1",
    },
    {
      title: "HEALTHY",
      value: "1",
    },
    {
      title: "UNASSOCIATED",
      value: "1",
    },
    {
      title: "OFFLINE",
      value: "1",
    },
  ];
  public showEmptyError = "Fetching reports, please wait..";
  public sitesList: any = [];
  public check = 0;
  public objBread: any;
  public pageName: string;
  public _lastUpdate: any;
  disablePlantButton: boolean;
  public isDisabled: boolean;
  public userRoll: any;
  public _timeOut: any;
  public hideItemsFromAssets = false;
  // public clientName: string = "";
  public adminClinetLogin: boolean;
  public eventHoverOnCard: any;
  public intervalVar: any;
  public devicedata: any;
  public _driveTemps: any = [];
  public _rmsAccels: any = [];
  showNav: boolean;
  public mouseenter: boolean;
  public hidePopover: boolean;
  public mouseleave: boolean;
  public _greenRmsIcon: boolean = false;
  public _yellowRmsIcon: boolean = false;
  public _redRmsIcon: boolean = false;
  public shouldShow: boolean;
  public checkClass: string;
  public company_name: string;
  public userID: any;
  public reportDataArr: any = [];
  public filet: any;
  public hasReports = true;
  public btnID_1 : boolean = true;
  public btnID_2 : boolean = false;
  public btnID_3 : boolean = false;
  public btnID_4 : boolean = false;
  public btnID_7 : boolean = false;
  searchedKey: string = "";
  page = 1;
  count = 0;
  tableSize = 10;

  public paginatedReportDataArr: any = [];

  selectedUserId: any = null;
  // tableSizes = [3, 6, 9, 12];

  public isAllSelected: boolean;
  allreports: any;
  macAdd: string = "";
  sNumber: string = "";
  site: string = "";
  application: string = "";
  createdDate: string = "";
  assetname: string = "";
  public fullName: string = "";

  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  public product_type :string = "rotating";
  public associated_clientid = null

  @ViewChild(MatPaginator) paginator: MatPaginator;

  // Defining the date picker range form group
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  public prodColor1: string ="active";
  public prodColor2: string;
  public prodColor3: string;
  public prodColor4: string;
  public prodColor7: string;
  public startDate: string = "";
  public endDate: string = "";
  public admin_clinet_id :any;
  public client_admin_id: string;
  public reportType: string = "Report";
  constructor(
    public router: Router,
    public menuService: MenuService,
    public activeRoute: ActivatedRoute,
    private changeService: ChangeUsersService,
    public dialog: MatDialog,
    private service: BackendApiService,
    private cdr: ChangeDetectorRef
  ) {

    if(localStorage.getItem('role')=='ADMIN') this.userID = localStorage.getItem("user_id");
    else if(localStorage.getItem('role')=="CLIENT") this.userID = localStorage.getItem("user_id");
    else this.userID = localStorage.getItem("associated_clientid");
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.userRoll = localStorage.getItem("role");
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit() {
    this.filet = "Report"; // Set the default value for the radio button
    this.getProductType(); //fetch the product type

    if(this.userRoll == 'ADMIN'){
      this.fetchInitialReports('rotating')
    }
  }

  private async fetchInitialReports(product_type) {
    try {
      this.product_type = product_type;
      await this.fetchReportsAndProcess(this.filet, this.product_type);
      // await this.getallDevices(
      //   this.currentPage,
      //   this.itemsPerPage,
      //   "",
      //   "",
      //   "",
      //   "",
      //   ""
      // );
      this.cdr.detectChanges(); // Trigger change detection after data is fetched and processed
    } catch (error) {
      console.error("Error fetching initial reports:", error);
    }
  }

  gridLayout() {
    this.gridLayoutOn = false;
    this.listLayoutOn = true;
  }

  listLayout() {
    this.gridLayoutOn = true;
    this.listLayoutOn = false;
  }

  viewReport(url) {
    let body: any = {
      key: url,
    };
    this.service
      .postAssetReport(this.report_generate + "/" + "pre-signed-url", body)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).status == "success") {
          if (JSON.parse(JSON.stringify(res)).body != "") {
            let report_url = JSON.parse(JSON.stringify(res)).body;
            window.open(report_url, "_blank");
          } else {
            this.service.showError("Something went wrong");
          }
        } else {
          this.service.showError("Something went wrong");
        }
      });
    // if (url !== undefined) {
    //   window.open(url, "_blank");
    // }
  }
  downloadReport(url,idx) {
    this.paginatedReportDataArr[idx].loader=true;
    let body: any = {
      key: url,
    };
    this.service
      .postAssetReport(this.assetServiceUrl + "/" + "download-report", body)
      .then((res) => {
        const responseData = JSON.parse(JSON.stringify(res)).data;
        if (responseData.status === "success") {
          const pdfFilePath = responseData.pdfFilePath;
          const link = document.createElement('a');
          link.href = pdfFilePath;
          // link.target = "_blank"; // Force the "Save As" dialog in most browsers
          document.body.appendChild(link); // Append the link to the body
          link.click(); // Trigger the download
          setTimeout(()=>{
            this.paginatedReportDataArr[idx].loader=false;
          },1800)
          document.body.removeChild(link); // Remove the link after triggering
        } else {
          this.paginatedReportDataArr[idx].loader=false;
          this.service.showError("Something went wrong");
        }
      })
      .catch(err => {
        this.paginatedReportDataArr[idx].loader=false;
        this.service.showError("Something went wrong");
      });
}



  selectProductType(value) {
    localStorage.setItem("dataInterval", value);
    switch (value) {
      case "rotating":
        this.fetchInitialReports(value);
        this.prodColor1 = "active";
        this.prodColor2 = "";
        this.prodColor3 = "";
        this.prodColor4 = "";
        break;
      case "transformer":
        this.prodColor1 = "";
        this.prodColor2 = "active";
        this.prodColor3 = "";
        this.prodColor4 = "";
        this.prodColor7 = "";
        this.fetchInitialReports(value);
        break;
      case "emeter":
        this.prodColor2 = "";
        this.prodColor1 = "";
        this.prodColor3 = "active";
        this.prodColor4 = "";
        this.prodColor7 = "";
        this.fetchInitialReports(value);
        break;
      case "eboiler":
        this.prodColor4 = "active";
        this.fetchInitialReports(value);
        this.prodColor1 = "";
        this.prodColor2 = "";
        this.prodColor3 = "";
        this.prodColor7 = "";
        break;
        case "oven":
          this.prodColor4 = "active";
          this.fetchInitialReports(value);
          this.prodColor1 = "";
          this.prodColor2 = "";
          this.prodColor3 = "";
          this.prodColor7 = "active";
    }
  }


  // onTableDataChange(event) {
  //   console.log(event, "change event");
  //   this.page = event;
  //   // Check if there are filtered dates and call onDateRangeChange with those dates
  //   if (
  //     this.range.controls["start"].value &&
  //     this.range.controls["end"].value
  //   ) {
  //     this.onDateRangeChange(
  //       this.range.controls["start"].value,
  //       this.range.controls["end"].value
  //     );
  //   } else {
  //     // If no filtered dates, fetch data for the next page without date range filter
  //     this.getallDevices(
  //       this.page,
  //       this.userID,
  //       this.clientName,
  //       this.site,
  //       this.application,
  //       this.assetname,
  //       this.createdDate
  //     );
  //   }
  // }

  onPageChange(event: PageEvent) {
    this.tableSize = event.pageSize;
    this.page = event.pageIndex + 1;
    this.fetchAndDisplayReports(
      this.reportType
    );
  }

  private async applyDateFilterWithPaging(reportType: string) {
    const start = this.range.controls["start"].value;
    const end = this.range.controls["end"].value;
    const formattedStartDate = moment(start).startOf("day").toISOString();
    const formattedEndDate = moment(end).endOf("day").toISOString();

    try {
      let response = await this.fetchFilteredReports(
        formattedStartDate,
        formattedEndDate,
        reportType,
        this.product_type
      );
      this.processReportsResponse(response);
    } catch (error) {
      console.error("Error in applyDateFilterWithPaging:", error);
      this.handleReportsError();
    }
  }

  private async fetchReportsAndProcess(reportType: string, product_type) {
    // Fetch reports based on the report type
    try {
      this.product_type = product_type;
      let response = await this.fetchFilteredReports(this.startDate, this.endDate, reportType, this.product_type);
      this.processReportsResponse(response);
    } catch (error) {
      console.error("Error in fetchReportsAndProcess:", error);
      this.handleReportsError();
    }
  }

  updateReportData() {
    // This logic might not be necessary if each page's data is fetched separately
    const startIndex = (this.page - 1) * this.tableSize;
    const endIndex = Math.min(
      startIndex + this.tableSize,
      this.reportDataArr.length
    );
    this.paginatedReportDataArr = this.reportDataArr.slice(
      startIndex,
      endIndex
    );
  }

  async getallDevices(
    page,
    user_id,
    termcompanyname,
    site,
    application,
    assetName,
    createdDate
  ) {
    // Figure out why endpoint for client isn't working
    let endpoint = `${this.assetServiceUrl}/report/${this.product_type}/${
      Math.floor(Math.random() * 90 + 10) +
      user_id +
      Math.floor(Math.random() * 9000 + 1000)
    }?page=${page}&pageSize=${this.tableSize}&role=${localStorage.getItem(
      "role"
    )}&company=${termcompanyname}&application=${application}&site=${site}&asset=${assetName}&date=${createdDate}`;
    if (
      createdDate == "" &&
      assetName == "" &&
      application == "" &&
      site == "" &&
      termcompanyname == ""
    ) {
      endpoint = `${this.assetServiceUrl}/report/${this.product_type}/${
        Math.floor(Math.random() * 90 + 10) +
        user_id +
        Math.floor(Math.random() * 9000 + 1000)
      }?page=${page}&pageSize=${this.tableSize}&role=${localStorage.getItem(
        "role"
      )}&company=${termcompanyname}&application=${application}&site=${site}&asset=${assetName}&endDate=${createdDate}&startDate=${createdDate}`;
    }
    try {
      const response = await this.service.getData(endpoint);
      const typedResponse = response as {
        data: {
          body: any[];
          page: {
            totalItems: number;
            currentPage: number;
            itemsPerPage: number;
          };
        };
      };

      if (typedResponse.data.body.length === 0) {
        this.hasReports = false;
        this.showEmptyError = "No Reports Available!";
        this.showNav = false;
      } else {
        this.hasReports = true;
        this.showNav = true;
        this.showEmptyError = "";
        this.count = typedResponse.data.page.totalItems;
        this.reportDataArr = typedResponse.data.body.map((val) => {
          let DateUtc = moment.utc(val.created_at);
          let localDate = DateUtc.local();
          return {
            ...val,
            created_at: new ConvertDatetimePipe().convertDateTime(localDate),
          };
        });
        this.paginatedReportDataArr = this.reportDataArr; // Directly assign fetched data
        this.cdr.detectChanges(); // trigger change detection
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.hasReports = false;
      this.showEmptyError = "Error fetching data";
      this.showNav = false;
    }
  }

  searchData(ev) {
    this.createdDate = ev;
    this.fetchAndDisplayReports(
      this.filet === "summary" ? "Report_Summary" : "Report"
    );
  }

  searchDatabysite(ev) {
    this.site = ev;
    this.fetchAndDisplayReports(
      this.filet === "summary" ? "Report_Summary" : "Report"
    );
  }

  searchDatabyApplication(ev) {
    this.application = ev;
    this.fetchAndDisplayReports(
      this.filet === "summary" ? "Report_Summary" : "Report"
    );
  }

  searchDatabyassetname(ev) {
    this.assetname = ev;
    this.fetchAndDisplayReports(
      this.filet === "summary" ? "Report_Summary" : "Report"
    );
  }

  searchDatabycompanyname(ev) {
    this.termcompanyname = ev;
    this.fetchAndDisplayReports(
      this.filet === "summary" ? "Report_Summary" : "Report"
    );
  }

  async filetype(filterType: string) {
    this.selectedReportType = filterType;
    this.page = 1;

    switch (filterType) {
      case 'summary':
        this.reportType = 'Summary';
        break;
      case 'ondemand':
        this.reportType = 'On-Demand_SA';
        break;
      case 'anomaly':
        this.reportType = 'Anomaly_SA';
        break;
      case 'periodic':
        this.reportType = 'Periodic_SA';
        break;
      case 'all':
      default:
        this.reportType = 'Report';
        break;
    }

    this.fetchAndDisplayReports(this.reportType);
  }

  // SOON TO BE DEPRECATED
  // private async fetchReports(reportType: string) {
  //   const endpoint = this.constructReportEndpoint(reportType);
  //   return await this.service.getData(endpoint);
  // }

  private constructReportEndpoint(reportType: string) {
    const randomSuffix =
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    let queryParams = new URLSearchParams({
      page: this.page.toString(),
      pageSize: this.tableSize.toString(),
      role: localStorage.getItem("role"),
      fullname: this.fullName,
      company: this.termcompanyname,
      application: this.application,
      site: this.site,
      asset: this.assetname,
      reportType: reportType,
      startDate: "",
      endDate: "",
    });

    // Add startDate and endDate if they are present
    if (this.range.controls["start"].value) {
      queryParams.set(
        "startDate",
        moment(this.range.controls["start"].value).startOf("day").toISOString()
      );
    }

    if (this.range.controls["end"].value) {
      queryParams.set(
        "endDate",
        moment(this.range.controls["end"].value).endOf("day").toISOString()
      );
    }

    return `${
      this.assetServiceUrl
    }/report/${this.product_type}/${randomSuffix}?${queryParams.toString()}`;
  }

  filterByDateRange(start, end) {
    return this.allDeviceSecondArray.filter((report) => {
      const date = new Date(report.created_at);
      return date >= start && date <= end;
    });
  }

  async onDateRangeChange(start: Date, end: Date) {
    const formattedStartDate = moment(start).startOf("day").toISOString();
    const formattedEndDate: any = moment(end == null ? new Date() : end)
      .endOf("day")
      .toISOString();

    // Determine the report type based on the current filter selection
    let reportType = this.filet === "summary" ? "Report_Summary" : "Report";
    this.startDate = formattedStartDate;
    this.endDate = formattedEndDate;
    try {
      let response = await this.fetchFilteredReports(
        formattedStartDate,
        formattedEndDate == null ? "" : formattedEndDate,
        reportType,
        this.product_type
      );
      this.processReportsResponse(response);
    } catch (error) {
      console.error("Error in onDateRangeChange:", error);
      this.handleReportsError();
    }
  }

  // Extracted method to fetch filtered reports
  private async fetchFilteredReports(
    startDate: string,
    endDate: string = "",
    reportType: string,
    product_type
  ) {
    this.product_type = product_type;
    // this.assetServiceUrl='http://localhost:3522/service'
    const endpoint = `${this.assetServiceUrl}/report/${this.product_type}/${
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000)
    }?page=${this.page}&pageSize=${this.tableSize}&role=${localStorage.getItem(
      "role"
    )}&company=${this.termcompanyname}&application=${this.application}&site=${
      this.site
    }&asset=${
      this.assetname
    }&reportType=${reportType}&startDate=${startDate}&endDate=${endDate}`;
    return await this.service.getData(endpoint);
  }

  // Extracted method to process reports response
  private processReportsResponse(response) {
    const reports = JSON.parse(JSON.stringify(response)).data.body;
    if (reports.length === 0) {
      this.noReportsAvailable();
      return;
    }

    this.hasReports = true;
    this.showNav = true;
    this.showEmptyError = "";
    this.count = JSON.parse(JSON.stringify(response)).data.page.totalItems;
    this.reportDataArr = this.convertReportDates(reports);
    this.updatePaginatedReports();

    if (this.reportDataArr.length > 0) {
      this.hasReports = true;
      this.showEmptyError = "";
    } else {
      this.noReportsAvailable();
    }
  }

  private noReportsAvailable() {
    this.reportDataArr = [];
    this.paginatedReportDataArr = [];
    this.hasReports = false;
    this.showEmptyError = "No Reports Available!";
    this.showNav = false;
  }

  // Convert report dates to local time
  private convertReportDates(reports) {
    return reports.map((val) => {
      let DateUtc = moment.utc(val.created_at);
      let localDate = DateUtc.local();
      return {
        ...val,
        created_at: new ConvertDatetimePipe().convertDateTime(localDate),
      };
    });
  }

  private handleReportsError() {
    // Update UI on error
    this.reportDataArr = [];
    this.paginatedReportDataArr = [];
    this.hasReports = false;
    this.showEmptyError = "Error fetching data";
    this.showNav = false;
  }

  private updatePaginatedReports() {
    this.paginatedReportDataArr = this.reportDataArr.slice(0, this.tableSize);
    this.cdr.detectChanges(); // Manually trigger change detection
  }

  private async fetchAndDisplayReports(reportType: string) {
    const endpoint = this.constructReportEndpoint(reportType);
    try {
      let response = await this.service.getData(endpoint);
      this.processReportsResponse(response);
    } catch (error) {
      console.error("Error fetching reports:", error);
      this.handleReportsError();
    }
  }

  // Function to clear filters and fetch all reports
  clearFilters() {
    // Clear the date range form controls
    this.range.controls["start"].setValue(null);
    this.range.controls["end"].setValue(null);

    // Reset filter terms
    this.termcompanyname = "";
    this.site = "";
    this.assetname = "";
    this.application ="";
    this.startDate = "";
    this.endDate = "";
    // Reset the page number to 1
    this.page = 1;

    // Fetch all reports without date range filter
    this.getallDevices(this.page, this.userID, "", "", "", "", "");
  }

  //get product type to show tab
  getProductType() {
    if(this.userID ==1){
      this.client_admin_id = localStorage.getItem('admin_client_id');
    }else{
      this.client_admin_id =this.userID;
    }
    this.service.getData(this.productApi +"/" + Math.floor(Math.random() * 90 + 10) + this.client_admin_id + Math.floor(Math.random() * 9000 + 1000)).then(res =>{
        let response = JSON.parse(JSON.stringify(res)).data;
        if(response.status === "success"){
          console.log(response.body.body,'response.body.body')
          if(response.body.body.length != 0 ){
            for(let i = 0; i < response.body.body.length; i++ ){
              // if(response.body.body[i].subsystem_type === 'RotatingAsset'){
              //   this.totalNumberRotatingDevice = response.body.body[i].count;
              // }
              // else
              if(response.body.body[i].subsystem_type === 'custom-TBoiler'){
                this.btnID_2 = true;
              }else if(response.body.body[i].subsystem_type === 'transformer'){
                this.btnID_4 = true;
              }else if(response.body.body[i].subsystem_type === 'emeter'){
                this.btnID_3 = true;
              }
              else if(response.body.body[i].subsystem_type === 'custom-oven'){
                this.btnID_7 = true;
              }
            }
            
          }else{
            this.btnID_1 = true;
            this.btnID_2 = false;
            this.btnID_3 = false;
            this.btnID_4 = false;
            this.btnID_7 = false;
          }
        }else{
            this.btnID_1 = true;
            this.btnID_2 = false;
            this.btnID_3 = false;
            this.btnID_4 = false;
            this.btnID_7 = false;
        }
        this.fetchProductCount()

    });
  }
   public rotatingAssetCount=0;
   async fetchProductCount() {
    try {
      const apiUrl = `${BaseUrlConstantsService.PRODUCT_LIST_API}/22${this.userID }2222`;
      const response: any = await this.service.getDataV2(apiUrl);
      if (response?.data?.status === "success") {
        this.rotatingAssetCount = response.data.body.body[0].count;
      } else {
        this.rotatingAssetCount = 0; // Default to 0 if api fails or no data
      }
      if(this.userID==594){
        this.rotatingAssetCount = 1;
      }
      // Call this here to refresh the menu once the count is known
      // this.updateMenuOptions();
    } catch (error) {
      console.log(error);
      this.rotatingAssetCount = 0;
      // this.updateMenuOptions();
    }finally{
      if(this.rotatingAssetCount==0){
        console.log(`No Rotating Assets Found`);
        if(this.btnID_7==true){
          this.product_type='oven';
          this.selectProductType('oven')
          // this.fetchInitialReports(this.product_type); // Fetch the initial reports based on the default value
        }
      }else{
        this.selectProductType('rotating')
        // this.fetchInitialReports(this.product_type); // Fetch the initial reports based on the default value
      }

    }
  }

}
